'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setLang = setLang;
exports.loadTranslations = loadTranslations;

var _translations = require('json/translations.json');

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_LOCALE = 'redux-frontend/language/SET_LOCALE';
var LOAD_TRANSLATIONS = 'redux-frontend/language/LOAD_TRANSLATIONS';
var LOAD_TRANSLATIONS_SUCCESS = 'redux-frontend/language/LOAD_TRANSLATIONS_SUCCESS';
var LOAD_TRANSLATIONS_FAIL = 'redux-frontend/language/LOAD_TRANSLATIONS_FAIL';

var LOAD_COMBINED_STATIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_STATIC_SUCCESS';

var initialState = {
  messages: [],
  loaded: false,
  locale: 'en'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_LOCALE:
      return (0, _extends3.default)({}, state, {
        locale: action.payload
      });
    case LOAD_TRANSLATIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        messages: action.result
      });
    case LOAD_COMBINED_STATIC_SUCCESS:
      // const messages = action.result.translations;
      // console.log('LOCALE 2', action.locale);
      return (0, _extends3.default)({}, state, {
        // messages: action.result.translations,
        messages: _translations2.default[action.locale || 'en'],
        loaded: true
      });
    default:
      return state;
  }
}

function setLang(lang) {
  return {
    type: SET_LOCALE,
    payload: lang
  };
}

function loadTranslations() {
  return {
    types: [LOAD_TRANSLATIONS, LOAD_TRANSLATIONS_SUCCESS, LOAD_TRANSLATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/translation');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/language.js
// module id = 1703
// module chunks = 47